import { render, staticRenderFns } from "./Swap.vue?vue&type=template&id=2bd90757&scoped=true&"
import script from "./Swap.vue?vue&type=script&lang=ts&"
export * from "./Swap.vue?vue&type=script&lang=ts&"
import style0 from "./Swap.vue?vue&type=style&index=0&id=2bd90757&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd90757",
  null
  
)

export default component.exports